import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';

// components
import { FormattedMessage } from 'react-intl';
import { Button } from 'dibs-elements/exports/Button';

// mutations
import { SharedModifyPortfolioItems } from '../../mutations/SharedModifyPortfolioItems';

// helpers
import { intlShape, injectIntl } from 'react-intl';
import { trackPurchaseClick } from '../tracking/actionButtonsTracking';
import { setCartItems } from '../../actions/sharedMobileActions';

// styles
import styles from './PdpSharedButtons.scss';

export class PdpSharedPurchaseButtonComponent extends React.Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        const { dispatch, userId, itemId, item } = this.props;
        trackPurchaseClick(item);

        if (!userId) {
            // If no user, store item - it can be ADDed to cart when user logs in later
            dispatch(setCartItems(itemId));
        } else {
            // ADD item to user's cart
            this.addToCartMutation();
        }
        this.redirectToCheckout();
    }

    addToCartMutation() {
        const { relay, userId, itemId } = this.props;
        SharedModifyPortfolioItems.commit(relay.environment, {
            action: 'ADD',
            itemId,
            portfolioType: 'CART',
            userId,
            onCompleted: () => {
                this.redirectToCheckout();
            },
            onError: () => {
                this.redirectToCheckout();
            },
        });
    }

    getCheckoutUrl() {
        const { quantitySelected, itemId, skuId } = this.props;
        const href = `/checkout/id-${itemId}/`;
        const params = [];

        if (quantitySelected) {
            params.push(`quantity=${quantitySelected}`);
        }
        if (skuId) {
            params.push(`skuId=${skuId}`);
        }
        return `${href}${params.length ? '?' : ''}${params.join('&')}`;
    }

    redirectToCheckout() {
        const checkoutUrl = this.getCheckoutUrl();
        window.location.assign(checkoutUrl);
    }

    render() {
        const { isPrimary } = this.props;
        const additionalProps = !isPrimary ? { type: 'secondary' } : {};

        return (
            <Button
                className={`${styles.button} ${styles.fullWidth}`}
                dataTn="item-actions-purchase-item"
                onClick={this.onClick}
                size={this.props.size}
                {...additionalProps}
            >
                <FormattedMessage
                    id="PdpSharedPurchaseButton.purchaseCta"
                    defaultMessage="Purchase"
                />
            </Button>
        );
    }
}

PdpSharedPurchaseButtonComponent.defaultProps = {
    size: 'large',
    isPrimary: true,
};

PdpSharedPurchaseButtonComponent.propTypes = {
    item: PropTypes.object.isRequired,
    quantitySelected: PropTypes.string,
    relay: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    itemId: PropTypes.string,
    userId: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    intl: intlShape.isRequired,
    isPrimary: PropTypes.bool,
    skuId: PropTypes.string,
};

PdpSharedPurchaseButtonComponent = connect()(injectIntl(PdpSharedPurchaseButtonComponent));

export const PdpSharedPurchaseButton = createFragmentContainer(PdpSharedPurchaseButtonComponent, {
    item: graphql`
        fragment PdpSharedPurchaseButton_item on Item {
            serviceId
            pdpTrackingVpvParams(userId: $userId) @include(if: $isClient)
            contemporaryTrackingString
            title
            seller {
                serviceId
            }
            pricing {
                totalAmount {
                    amount
                }
            }
            categoryCode
            browseUrl
        }
    `,
});
